import { getAddress } from "ethers";
import { SiweMessage } from "siwe";

import { getAuthNonce, verifyAuthMessage } from "lib/apis/auth";
import type { VerifyResponse } from "lib/apis/auth";

import { saveAccessToken } from "./authToken";

type LoginWithSiweParams = {
  address: string;
  chainId: number;
  signMessageAsync: (args: { message: string }) => Promise<`0x${string}` | string>;
};

export async function loginWithSiwe({
  address,
  chainId,
  signMessageAsync,
}: LoginWithSiweParams): Promise<VerifyResponse> {
  const checksummed = getAddress(address);
  const challenge = await getAuthNonce(checksummed);

  const siwe = new SiweMessage({
    domain: challenge.domain,
    address: checksummed,
    statement: challenge.statement || "Sign in to Nectar",
    uri: challenge.uri,
    version: challenge.version || "1",
    chainId: challenge.chainId ?? chainId,
    nonce: challenge.nonce,
  });

  const message = siwe.prepareMessage();
  const signature = await signMessageAsync({ message });
  const session = await verifyAuthMessage({ message, signature });

  saveAccessToken(session.accessToken, session.address);
  return session;
}
